import React from "react";
import { Link } from "react-router-dom";
import "../style/doctors.css";

import doctor1 from "../assets/doc.jpg";
import doctor2 from "../assets/doc.jpg";
import doctor3 from "../assets/doc.jpg";
import doctor4 from "../assets/docsumit.jpg";
import doctor5 from "../assets/doc.jpg";
import doctor6 from "../assets/doc.jpg";
import doctor7 from "../assets/docchintan.jpg";

const doctors = [
  {
    img: doctor1,
    name: "Dr. Neel Patel",
    specialty: "MD Physician",
    phone: "+91-84808 01010",
    email: "example@example.com",
    link: "/doctors/neel-patel"
  },
  {
    img: doctor2,
    name: "Dr. Darshak Patel",
    specialty: "Ortho Surgeon",
    phone: "+91-84808 01010",
    email: "example@example.com",
    link: "/doctors/darshak-patel"
  },
  {
    img: doctor3,
    name: "Dr. Purvesh Bhatt",
    specialty: "General Surgeon",
    phone: "+91-84808 01010",
    email: "example@example.com",
    link: "/doctors/purvesh-bhatt"
  },
  {
    img: doctor4,
    name: "Dr. Sumit Patel",
    specialty: "Pediatrician",
    phone: "+91-84808 01010",
    email: "example@example.com",
    link: "/doctors/sumit-patel"
  },
  {
    img: doctor5,
    name: "Dr. Mayur Patel",
    specialty: "Pediatrician",
    phone: "+91-84808 01010",
    email: "example@example.com",
    link: "/doctors/mayur-patel"
  },
  {
    img: doctor6,
    name: "Dr. Dhaval Patel",
    specialty: "Pediatrician",
    phone: "+91-84808 01010",
    email: "example@example.com",
    link: "/doctors/dhaval-patel"
  },
  {
    img: doctor7,
    name: "Dr. Chintan Thanki",
    specialty: "Critical Care",
    phone: "+91-84808 01010",
    email: "example@example.com",
    link: "/doctors/chintan-thanki"
  },
];

const Doctors = () => {
  return (
    <div className="doctors-section">
      <div className="container">
        <div className="doc-title-je">
          <div className="doc-main-jp">
            <span className="our-docs">— OUR DOCTORS —</span>
          </div>
        </div>

        <div className="doc-grid">
          {doctors.map((doc, i) => (
            <Link to={doc.link} key={i} className="doctor-card-link">
              <div className="doctor-card">
                <img src={doc.img} alt={doc.name} className="doctor-img" />

                <div className="doctor-info">
                  <h3 className="doctor-name">{doc.name}</h3>
                  <p className="doctor-specialty">{doc.specialty}</p>
                  {doc.desc && <p className="doctor-desc">{doc.desc}</p>}
                </div>

                <div className="doctor-contact">
                  <p>📞 {doc.phone}</p>
                  <p>📧 {doc.email}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Doctors;
